import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"}
}
const _hoisted_6 = {
  key: 1,
  style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"}
}
const _hoisted_7 = {
  key: 2,
  class: "dropdown ml-2"
}
const _hoisted_8 = {
  class: "btn btn-link",
  style: {"font-size":"2em","padding":"0"},
  "data-toggle": "dropdown"
}
const _hoisted_9 = {
  class: "dropdown-menu dropdown-menu-scrollable",
  role: "menu"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_15 = { class: "dropdown mr-1" }
const _hoisted_16 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_17 = { class: "dropdown-menu" }
const _hoisted_18 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_19 = {
  type: "button",
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = ["onClick"]

import { computed, onMounted, watch, type Ref } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue"
    import Navigation from '@common/Navigation.vue'
    import PnlViewer from "@Quest/Pnls/Components/PnlViewer.vue"

    import { CurrencyDenomination } from '@common/types'
    import type { PnlTemplateReadModel } from '@Quest/Pnls/readmodels'
    import type { AlternativesViewDefReadModel, PnlPageReadModel } from '@Quest/Portfolios/readmodels'

    import { usePnlPageQueryV1 } from '@Quest/Portfolios/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PnlPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))

    const viewDefId = computed(() => route.params.viewDefId as string | null)
    const pnlTemplateId = computed<string | null>(() => (route.query.pnlTemplateId as string) ?? null)
    const denomination = computed<CurrencyDenomination>(() => (route.query.denomination as CurrencyDenomination) ?? CurrencyDenomination.Million)
    const applyBenefitsConfidenceFactor = computed<boolean>(() => route.query.risk === "true")
    const cagrVisible = computed(() => route.query.cagr === "true")

    const {
        runPnlPageQueryV1,
        modelPnlPageQueryV1
    } = usePnlPageQueryV1(workspaceId, tchProjectId, viewDefId, pnlTemplateId, applyBenefitsConfidenceFactor, denomination)

    const rm = modelPnlPageQueryV1 as Ref<PnlPageReadModel | null>
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const pnlTemplates = computed<PnlTemplateReadModel[]>(() => rm.value?.Templates ?? [])
    const views = computed<AlternativesViewDefReadModel[]>(() => rm.value?.Lists ?? [])
    const pnlTemplateName = computed(() => rm.value?.PnlTemplateName ?? '')
    const viewDefName = computed(() => rm.value?.ViewDefName ?? '')

    const activeSharesCount = computed<number | null>(() => rm.value?.ActiveSharesCount ?? null)
    const shareId = computed<string>(() => rm.value?.ShareId ?? '')

    function setViewDefId(newViewDefId: string | null)
    {
        const basePath = `/portfolio/pnl/${workspaceId.value}/${tchProjectId.value}`

        const path = newViewDefId
            ? `${basePath}/${newViewDefId}`
            : basePath

        router.push({
            path,
            query: { ...route.query }
        })
    }

    function setDenomination(newDenomination: string)
    {
        router.replace({
            params: { ...route.params },
            query: { ...route.query, denomination: newDenomination }
        })
    }

    function setPnlTemplate(newId: string | null)
    {
        const query = { ...route.query }

        if (newId)
            query.pnlTemplateId = newId
        else
            delete query.pnlTemplateId

        router.replace({
            params: { ...route.params },
            query
        })
    }

    function toggleBenefitsConfidenceFactor()
    {
        router.replace({
            params: { ...route.params },
            query: {
                ...route.query,
                risk: String(!applyBenefitsConfidenceFactor.value)
            }
        })
    }

    function toggleCagr()
    {
        router.replace({
            params: { ...route.params },
            query: {
                ...route.query,
                cagr: String(!cagrVisible.value)
            }
        })
    }

    onMounted(() =>
    {
        document.title = "P&L | TransparentChoice"
        //runPnlPageQueryV1()
    })


    watch(() => route.fullPath, () => {
            runPnlPageQueryV1()
    },
    { immediate: true })


return (_ctx: any,_cache: any) => {
  return (_unref(rm))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isWorkspaceMember.value)
          ? (_openBlock(), _createBlock(PortfolioNavigation, {
              key: 0,
              workspaceId: workspaceId.value,
              projectId: tchProjectId.value
            }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
          : (_openBlock(), _createBlock(Navigation, { key: 1 })),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!isWorkspaceMember.value)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_5, " P&L: " + _toDisplayString(viewDefName.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (isWorkspaceMember.value)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_6, "P&L:"))
                : _createCommentVNode("v-if", true),
              (isWorkspaceMember.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("a", _hoisted_8, [
                      _createTextVNode(_toDisplayString(viewDefName.value) + " ", 1 /* TEXT */),
                      _cache[5] || (_cache[5] = _createElementVNode("i", {
                        class: "fa fa-caret-down",
                        style: {"font-size":"0.7em","vertical-align":"middle"}
                      }, null, -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (setViewDefId(null)))
                      }, "All"),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "dropdown-header" }, "Custom lists", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(views.value, (v) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          key: v.Id,
                          onClick: ($event: any) => (setViewDefId(v.Id))
                        }, _toDisplayString(v.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (isWorkspaceMember.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "btn btn-outline-secondary",
                    style: {"padding":"0.7em 2em"},
                    href: `/#/sharing/resource/PortfolioPnlsDataShareResourceProvider/${shareId.value}`,
                    target: "_blank"
                  }, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Share ", -1 /* CACHED */)),
                    (activeSharesCount.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(activeSharesCount.value) + ")", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_12))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 20px"} }, null, -1 /* CACHED */)),
          _createElementVNode("nav", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn mr-1", applyBenefitsConfidenceFactor.value ? 'btn-danger' : 'btn-outline-secondary']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleBenefitsConfidenceFactor()))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa-regular", applyBenefitsConfidenceFactor.value ? 'fa-square-check' : 'fa-square'])
              }, null, 2 /* CLASS */),
              _cache[9] || (_cache[9] = _createTextVNode(" Risk adjusted benefits ", -1 /* CACHED */))
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn mr-1", cagrVisible.value ? 'btn-info' : 'btn-outline-secondary']),
              onClick: toggleCagr
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa-regular", cagrVisible.value ? 'fa-square-check' : 'fa-square'])
              }, null, 2 /* CLASS */),
              _cache[10] || (_cache[10] = _createTextVNode(" CAGR ", -1 /* CACHED */))
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", _hoisted_16, _toDisplayString(denomination.value) + "s ", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {setDenomination('Million');})
                }, "Millions"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {setDenomination('Thousand');})
                }, "Thousands"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {setDenomination('Unit');})
                }, "Units")
              ])
            ]),
            (pnlTemplates.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("button", _hoisted_19, _toDisplayString(pnlTemplateName.value), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "dropdown-header" }, "P&L templates", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pnlTemplates.value, (t) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "dropdown-item",
                        key: t.Id,
                        onClick: ($event: any) => (setPnlTemplate(t.Id))
                      }, _toDisplayString(t.Name), 9 /* TEXT, PROPS */, _hoisted_21))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createVNode(PnlViewer, {
            readModel: _unref(rm).Report,
            cagrVisible: cagrVisible.value
          }, null, 8 /* PROPS */, ["readModel", "cagrVisible"])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})